import throttle from '../../../assets/js/base/_throttle.js';

const relatedContent = function(node) {
    if (!(node instanceof HTMLElement)) {
        return;
    }

    const wrap = node.querySelector('.related-content__items');

    if (!wrap) {
        return;
    }

    const items = Array.from(node.querySelectorAll('.related-content__item'));

    if (!items || !items.length) {
        return;
    }

    const header = node.querySelector('.related-content__header');
    let nav = null;

    if (header) {
        nav = header.querySelector('.related-content__nav');
        if (!nav) {
            nav = document.createElement('nav');
            nav.className = 'related-content__nav';
            header.appendChild(nav);
            console.log('Nav appended:', nav);
        }
    }

    const resize = () => {
        items.forEach(item => item.style.minHeight = '');
        const max = Math.max(...items.map(item => item.offsetHeight));
        items.forEach(item => item.style.minHeight = `${max}px`);
    }

    const flickity = new window.Flickity(wrap, {
        cellAlign: 'left',
        pageDots: false,
        imagesLoaded: true,
        prevNextButtons: nav instanceof HTMLElement && nav.parentNode,
        arrowShape: 'M100,55.5H22.1l33.8,31.4L48.4,95L0,50L48.4,5l7.5,8.1L22.1,44.5H100V55.5z',
        on: {
            ready: () => {
                resize();
                window.addEventListener('resize', throttle(resize, 25));

                if (nav instanceof HTMLElement) {
                    Array.from(node.querySelectorAll('.flickity-button')).forEach(button => nav.appendChild(button));
                    console.log('Buttons appended to nav:', nav);
                }
            },
            lazyLoad: () => {
                resize();
            }
        }
    });

    return flickity;
}

relatedContent.instances = Array.from(document.querySelectorAll('.related-content')).map(node => relatedContent(node));

export default relatedContent;
